"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var resize_detector_1 = require("resize-detector");
var utils_1 = require("../utils");
var hook_1 = require("./hook");
var underscoreWidth = 24;
function TabNavUnderscore(_a) {
    var prefix = _a.prefix, tabNavDom = _a.tabNavDom;
    var _b = react_1.useState(0), offset = _b[0], setOffset = _b[1];
    var _c = react_1.useState(0), domWidth = _c[0], setDomWidth = _c[1];
    var _d = hook_1.useTabs(), tabs = _d.tabs, type = _d.type;
    react_1.useEffect(function () {
        if (tabNavDom) {
            var handleDomChange_1 = function () {
                if (type === 'vertical') {
                    var offsetY = tabNavDom.offsetTop + (tabNavDom.offsetHeight - underscoreWidth) / 2;
                    setOffset(offsetY);
                }
                else if (type === 'button') {
                    setDomWidth(tabNavDom.clientWidth + 2);
                    setOffset(tabNavDom.offsetLeft);
                }
                else {
                    var offsetX = tabNavDom.offsetLeft + (tabNavDom.offsetWidth - underscoreWidth) / 2;
                    setOffset(offsetX);
                }
            };
            handleDomChange_1();
            resize_detector_1.addListener(tabNavDom, handleDomChange_1);
            return function () { return resize_detector_1.removeListener(tabNavDom, handleDomChange_1); };
        }
    }, [tabNavDom, type, tabs]); // 为了保证 TabPane 动态变化时 underscore 能够跟随变化，所以 tabs 依赖需要保留
    if (type === 'vertical') {
        return react_1.default.createElement("li", { className: utils_1.concat(prefix, 'underscore'), style: { height: underscoreWidth, top: offset } });
    }
    if (type === 'button') {
        return react_1.default.createElement("li", { className: utils_1.concat(prefix, 'underscore'), style: { width: domWidth, left: offset } });
    }
    return react_1.default.createElement("li", { className: utils_1.concat(prefix, 'underscore'), style: { width: underscoreWidth, left: offset } });
}
exports.default = TabNavUnderscore;
//# sourceMappingURL=TabNavUnderscore.js.map